// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2VM4e","info":"UpdateTermsInfo_info__2pFcB"};